__turbopack_context__.v({
  "article": "ArticleGrid-module-scss-module__s3ihUa__article",
});
